<template>
    <!-- 问题研讨 -->
    <div class="discu-box">
        <div class="title">{{ $t('问题研讨') }}</div>

        <div class="question-box">
            <template v-if="dataList.length > 0">

                <div class="list" v-for="(item, index) in dataList">
                    <div class="info df aic">
                        <div @click="handleOpenavatar(item)" class="df cup">
                            <el-avatar :size="24" :src="item.user_avatar_url" @error="true">
                                <img src="@/assets/images/avatar.png" alt="">
                            </el-avatar>
                        </div>
                        <span class="name">{{ item.is_expert == 10 ? item.user_name : item.user_nick_name }}</span>
                    </div>
                    <div class="desc">
                        {{ item.taqa_content }}
                    </div>
                    <div class="like-box df jcfe">
                        <el-button type="text" class="df aic" v-throttle="1000" @click="handleReplyPer(item)">
                            <span class="iconfont fs-15">&#xe60b;</span>{{ $t('回复') }}</el-button>
                        <el-button type="text" class="df aic" v-throttle="1000"
                            :class="{ 'have_like': item.have_like == 10 }" @click="handleactQuestionLike(item)">
                            <span class="iconfont">{{ item.have_like == 10 ? '&#xe656;' : '&#xe61b;' }}</span>
                            {{ item.taqa_likes ? item.taqa_likes : $t('点赞') }}
                        </el-button>
                    </div>

                    <div v-if="item.children.length > 0" style="padding-left:40px;">
                        <reply-list v-for="(items, indexs) in item.children" :key="indexs" :item="items"
                            :handleReplyPer="handleReplyPer" :handleactQuestionLike="handleactQuestionLike" />
                    </div>
                    <!--               
                    <template v-if="item.children.length > 0">
                        <div class="list" v-for="(items, indexs) in item.children" :key="indexs">
                            <div class="info df aic">
                                <el-avatar :size="24" :src="items.user_avatar_url"></el-avatar>
                                <span class="name">{{ items.user_nick_name }}</span>
                            </div>
                            <div class="desc">
                                {{ items.taqa_content }}
                            </div>
                            <div class="like-box df jcfe">
                                <el-button type="text" class="df aic" @click="handleReplyPer(items)"><img
                                        src="@/assets/images/path1.png" alt="">回复</el-button>
                                <el-button type="text" class="df aic" :class="{ 'have_like': items.have_like == 10 }"
                                    @click="handleactQuestionLike(items)">
                                    <span class="iconfont">{{ items.have_like == 10 ? '&#xe656;' : '&#xe61b;'
                                        }}</span>点赞
                                </el-button>
                            </div>
                        </div>
                    </template> -->

                </div>

            </template>
            <div class="no_news df fdc jcc aic" v-else>
                <img src="@/assets/images/no_news.png" alt="">
                <p>{{ $t('暂无消息') }}</p>
            </div>
        </div>

        <div class="reply-box df aic">
            <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 10 }" :placeholder="$t('请输入内容')"
                v-model="textarea">
            </el-input>
            <el-button type="text" class="ml-20" @click="handleReply">
                <img src="@/assets/images/public_send.png" alt=""></el-button>
        </div>

        <el-dialog :title="$t('回复')" :visible.sync="dialogVisible" width="570px">

            <div class="df reply-person">
                <span class="fn mr-16 c-9 fs-14">{{ $t('回复') }}</span>
                <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 10 }" :placeholder="$t('请输入您的回复')"
                    v-model="textareaper"></el-input>
            </div>
            <div class="languige-text harmonyos-text mt-24" v-if="userinfo.user_expert == 10">
                {{ $t('以实名身份发布') }}
                <el-tooltip :content="$t('以专家身份实名评论后页面会同步展示实名信息')" placement="bottom-start" effect="light">
                    <span class="iconfont">&#xe677;</span>
                </el-tooltip>
                <el-checkbox-group v-model="is_expert" style="display: inline-block;" class="ml-23">
                    <el-checkbox :key="10" :label="10">{{ $t('是') }}</el-checkbox>
                </el-checkbox-group>

            </div>

            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false" class="btn1">{{ $t('取消') }}</el-button>
                <el-button type="primary" class="btn2" @click="handelSubPer">{{ $t('确定') }}</el-button>
            </span>
        </el-dialog>


        <!-- 个人信息 -->
        <avatarTop ref="avatarDialog" @post-submitted="handleAvatarSubmitted" :id="ac_id" />

    </div>
</template>

<script>
import { getactQuestion, getactQuestionLike, setactQuestionAdd } from "@api/active";
import { getMyInfo, setuserfollowAdd } from "@api/home";
import replyList from "./replyList.vue";

export default {
    components: {
        replyList
    },
    props: {
        id: {
            type: [String, Number],
            required: true
        },
        data: {
            type: Array,
            default: []
        },
    },
    data() {
        return {
            dialogVisible: false,  //回复弹框
            dataList: [],
            userinfo: [],
            textarea: '',
            textareaper: '',  //回复别人的评论
            is_expert: [10],  //回复别人的评论
            personObj: {},

            ac_id: 0,


        }
    },
    watch: {
        data: {
            handler(newData) {
                this.dataList = this.data;
            },
            deep: true, // 如果需要深度监听数组中的对象变化，可以设置为 true
            immediate: true // 如果希望在组件创建时立即执行一次 handler
        }
    },

    mounted() {
        this.dataList = this.data;
        this.getCurrUserData();

    },
    methods: {

        errorHandler() {
            return true
        },
        async getCurrUserData() {
            let res = await getMyInfo();
            if (res.status == 200) {
                this.userinfo = res.data;
            }
        },

        handleOpenavatar(item) {
            if (item.user_id == 0 || item.user_id == null || item.user_nick_name == 0 || item.user_nick_name == null) {
                return false;
            }
            this.ac_id = item.user_id;
            this.$refs.avatarDialog.openModal();
            // 
        },
        // 个人信息谈款
        async handleAvatarSubmitted(id) {

            let res = await setuserfollowAdd({ tuf_be_follow_user_id: id });
            if (res.status == 200) {
                this.$message.success(res.msg);

            }

        },

        async getData() {
            let res = await getactQuestion({ id: this.id });
            this.dataList = res.data;
        },

        // 电站
        async handleactQuestionLike(item) {

            let res = await getactQuestionLike({ taqa_id: item.taqa_id });
            this.getData();
        },


        handleReply() {
            let obj = { ta_id: this.id, taqa_content: this.textarea };
            this.setactquestionAdd(obj);
            this.textarea = '';
        },

        handelSubPer() {
            this.is_expert = this.is_expert.length > 0 ? this.is_expert[0] : 20;
            let obj = { ta_id: this.id, taqa_content: this.textareaper, to_user_id: this.personObj.user_id, taqa_pid: this.personObj.taqa_id, is_expert: this.is_expert };
            this.setactquestionAdd(obj);
            setTimeout(() => {
                this.dialogVisible = false;
                this.textareaper = '';
                this.is_expert = [10];
            }, 200);
        },

        // 回复评论
        handleReplyPer(item) {
            this.dialogVisible = true;
            this.personObj = item;

        },
        // 评论
        async setactquestionAdd(obj) {
            let res = await setactQuestionAdd(obj);

            if (res.status == 200) {
                this.$message({
                    message: res.data.msg,
                    type: 'success',
                    customClass: 'mt-60' // 添加自定义类
                });
            }
            this.getData();
        },
    }
}
</script>


<style lang="scss" scoped>
.list {
    margin-top: 16px;


    .info {
        color: rgb(25, 25, 25);
        font-size: 16px;
        font-weight: 400;
        line-height: 22px;

        .name {
            margin-left: 12px;
            font-family: "MicrosoftYaHeiSemibold";
        }
    }

    .desc {
        margin-left: 36px;
        color: rgb(25, 25, 25);
        font-size: 14px;
        font-weight: 400;
        line-height: 22px;
        margin-top: 14px;
    }

    .like-box {
        margin-top: 8px;

        button {
            color: rgb(174, 174, 174);
            font-size: 14px;
            font-weight: 400;
            line-height: 22px;
            padding: 0 8px;

            &.have_like {
                color: rgb(216, 15, 5);
                ;
            }

            img,
            .iconfont {
                width: 16px;
                margin-right: 8px;
            }

            &:hover {
                color: rgb(216, 15, 5);
                ;

            }
        }

        .el-button+.el-button {
            margin-left: 0;
        }
    }
}

::v-deep() {
    .el-dialog__body {
        padding: 12px 20px 16px;
    }

    .el-dialog {
        border-radius: 8px;
    }

    .dialog-footer {

        .btn1,
        .btn2 {
            min-width: 75px;
            height: 36px;
            border-radius: 30px;
            padding: 0 16px;
        }

        .btn1 {
            background-color: #ffffff;
            border: 1px solid #ededed;
        }

        .btn2 {
            background-color: #D64F31;
            border: none;
        }

        .el-button+.el-button {
            margin-left: 24px;
        }
    }

}

.reply-person {
    background-color: #F8F8F8;
    padding: 16px;
    border-radius: 4px;

    ::v-deep() {
        .el-textarea__inner {
            border: none;
            padding: 0;
            background-color: transparent;
        }
    }
}

.reply-box {
    min-height: 88px;
    border: 0.5px solid rgb(201, 201, 201);
    border-radius: 8px;
    margin-top: 14px;
    margin-left: 36px;
    padding: 8px 20px 8px 12px;

    ::v-deep() {
        el-textarea {
            height: 100%;

        }

        .el-textarea__inner {
            border: none;
            min-height: 72px !important;

            &::-webkit-scrollbar {
                width: 0;
            }
        }
    }
}

.question-box {
    margin-top: 24px;

    // min-height: 310px;

    .no_news {
        height: 310px;

        p {
            color: rgb(119, 119, 119);

            font-size: 14px;
            font-weight: 400;
            line-height: 24px;
            margin-top: 4px;
        }
    }

}

.discu-box {
    padding-top: 40px;
    padding-bottom: 80px;

    .title {
        color: rgb(25, 25, 25);
        font-size: 20px;
        font-weight: 400;
        line-height: 30px;
        font-family: "MicrosoftYaHeiSemibold";
    }
}
</style>